/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { Tooltip } from 'appkit-react/lib/Tooltip';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';

import {
    GET_BATCH_TESTS_FOR_FFIEC031, GET_QUARTER_FILTERED_BATCH_TESTS_FOR_FFIEC031, GET_SUMMARY_QUARTERS_FOR_FFIEC031, GET_DOWNLOADED_RESULT, GET_LATEST_BATCH_FOR_FFIEC031,
} from 'Apollo/Queries/Rules/FFIEC031Results';
import {
    showReportMenuVar, getPreviousBatchVar, showBatchAlertVar, tenantIdVar,
    leftNavigationItemsVar, moduleIdVar, currentLeftMenuVar,
} from 'Apollo/config';
import { ModuleEnum } from 'constants';
import DiagnosticResultsUI from 'views/DiagnosticResults/components';
import crossReportImg from 'assets/images/cross-report-black.svg';
import StatusComponent from '../../../DiagnosticResults/components/StatusComponent';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem', color: '#464646' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const FFIEC031LandingPage = () => {
    const history = useHistory();
    const location = useLocation();
    const [regulation, setRegulation] = useState(location.state.regulation);
    const [selectedQuarter, setSelectedQuarter] = useState('');
    const [oneTimeFlag, setOneTimeFlag] = useState(true);
    const showBatchAlert = useReactiveVar(showBatchAlertVar);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [queryError, setQueryError] = useState(false);
    const getPreviousBatch = useReactiveVar(getPreviousBatchVar);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo query to fetch batch tests result  */
    const [getBatchTestData, { loading: isLoading, data }] = useLazyQuery(GET_BATCH_TESTS_FOR_FFIEC031, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                getPreviousBatch,
                tenantId,
            },
        },
    });

    /* Apollo query to fetch getCurrentStatusOfLatestBatch */
    const [getCurrentStatusOfLatestBatch, {
        data: { getCurrentStatusOfLatestBatchForFFIEC031 = {} } = {}, error: getCurrentStatusOfLatestBatchError, stopPolling,
    }] = useLazyQuery(GET_LATEST_BATCH_FOR_FFIEC031, {
        variables: {
            input: {
                tenantId,
            },
        },
        pollInterval: 20000,
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to download batch test result  */
    const [
        getDownloadedResult, {
            loading: isDownloading, data: {
                getFFIEC031SummaryDetailsForDownload = {},
            } = {},
        },
    ] = useLazyQuery(GET_DOWNLOADED_RESULT, {
        fetchPolicy: 'no-cache',
    });

    /* Apollo query fetch batch test result selected quarter  */
    const [getQuarterFilteredData, filteredBatchTests] = useLazyQuery(GET_QUARTER_FILTERED_BATCH_TESTS_FOR_FFIEC031, {
        fetchPolicy: 'no-cache',
    });

    /* Apollo query fetch to quarters  */
    const [getSummaryQuarter, summaryQuartersData] = useLazyQuery(GET_SUMMARY_QUARTERS_FOR_FFIEC031, {
        variables: {
            input: {
                tenantId,
            },
        },
    });

    const getLatestBatch = () => {
        stopPolling();
        setOneTimeFlag(true);
        getPreviousBatchVar(false);
        setShowSuccessAlert(false);
    };

    /* Breadcrumb items configuration */
    const breadcrumbItems = [
        {
            link: '',
            value: (
                <span
                    className="appkiticon icon-home-fill font-16"
                    onClick={
                        () => {
                            showReportMenuVar(false);
                            history.push('/');
                            leftNavigationItemsVar([]);
                            moduleIdVar(null);
                        }
                    }
                    role="presentation"
                />
            ),
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text">FFIEC031 Diagnostic Results</span>,
        },
    ];

    /* status component fetched from diagonstic result folder */
    const getSpanStyle = status => (
        <StatusComponent
            status={status}
        />
    );

    /* Column configuration for batch test summary table */
    const columns = [
        {
            Header: 'Rule ID',
            accessor: 'ruleId',
            minWidth: 50,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Schedule / Part',
            accessor: 'schedule',
            minWidth: 120,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'MDRM',
            accessor: 'mdrm',
            minWidth: 100,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Rule description',
            accessor: 'ruleDescription',
            minWidth: 250,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Enabled Y/N',
            accessor: 'isActive',
            minWidth: 90,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Rule applicable',
            accessor: 'isRuleApplicable',
            minWidth: 117,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { isRuleApplicable } } = row;
                return isRuleApplicable === 'N' ? (
                    <Tooltip content={<span className="a-h6">Applicability dependent on Low tier or High tier categorization</span>} placement="top" tooltipTheme="light">
                        {isRuleApplicable}
                    </Tooltip>
                )
                    : (
                        <span>{isRuleApplicable}</span>
                    );
            },
        },
        {
            Header: 'Test status',
            accessor: 'testRunStatus',
            minWidth: 90,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { isRuleApplicable, testRunStatus } } = row;
                return isRuleApplicable === 'N' ? (
                    <span
                        className="appkiticon
                        icon-alert-outline"
                        style={{ color: '#FFB600', fontSize: '1.3rem', marginLeft: '1rem' }}
                    />
                ) : getSpanStyle(testRunStatus);
            },
        },
    ];

    /* Method for sidebar navigation */
    const onNavigate = () => {
        // method for sidebar navigation
    };

    /* Navigates to upload report page */
    const uploadReport = () => {
        history.push(
            {
                pathname: '/UploadReport',
            },
        );
    };

    /* Calls the  getDownloadedResult */
    const downloadResult = async () => {
        const quarter = Math.floor(selectedQuarter.getMonth() / 3 + 1);
        const year = selectedQuarter.getFullYear();
        const qtrValue = `q${quarter}_${year}`;
        getDownloadedResult({
            variables: {
                input: {
                    tenantId,
                    period: qtrValue,
                },
            },
        });
    };

    /* Navigates to result page of specific rule */
    const onNavigateToResult = row => {
        history.push(
            {
                pathname: '/ffiec031results',
                state: {
                    batchId: row.batchId,
                    ruleId: row.ruleId,
                    period: row.period,
                    regulation,
                },
            },
        );
    };

    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.RULEENGINE);
    }, []);

    /* Side effect when location state updates */
    useEffect(() => {
        setRegulation(location.state.regulation);
        showReportMenuVar(true);
    }, [location]);

    /* Side effect when getPreviousBatch changed */
    useEffect(async () => {
        getBatchTestData();
        getSummaryQuarter();
        if (getPreviousBatch === true) {
            getCurrentStatusOfLatestBatch();
        }
    }, [getPreviousBatch]);

    /* Side effect when batchTestData changed to set selected quarter */
    useEffect(() => {
        if (data?.getFFIEC031BatchTests && data?.getFFIEC031BatchTests.length > 0) {
            const qtrValue = data.getFFIEC031BatchTests[0].period;
            const quarter = qtrValue.split('_')[0];
            const year = qtrValue.split('_')[1];
            let date;
            switch (quarter) {
                case 'q1':
                    date = new Date(year, 0, 1);
                    break;
                case 'q2':
                    date = new Date(year, 3, 1);
                    break;
                case 'q3':
                    date = new Date(year, 6, 1);
                    break;
                case 'q4':
                    date = new Date(year, 9, 1);
                    break;
                default:
                    break;
            }
            setSelectedQuarter(date);
        } else {
            setSelectedQuarter('');
        }
    }, [data]);

    /* Side effect when getCurrentStatusOfLatestBatchForFFIEC031 changed */
    useEffect(() => {
        const isCurrentStatusForLatestBatchAvailable = getCurrentStatusOfLatestBatchForFFIEC031.length > 0 && Object.keys(getCurrentStatusOfLatestBatchForFFIEC031[0]).length > 0;

        if (isCurrentStatusForLatestBatchAvailable && (
            (getCurrentStatusOfLatestBatchForFFIEC031[0]).batchRunStatus === 'Completed'
                || (getCurrentStatusOfLatestBatchForFFIEC031[0]).batchRunStatus === 'Failed')) {
            showBatchAlertVar(false);
            stopPolling();
        }
        if (isCurrentStatusForLatestBatchAvailable && (getCurrentStatusOfLatestBatchForFFIEC031[0]).batchRunStatus === 'Completed') {
            setShowSuccessAlert(true);
        }
    }, [getCurrentStatusOfLatestBatchForFFIEC031, stopPolling]);

    /* Side effect when getCurrentStatusOfLatestBatchError changed */
    useEffect(() => {
        if (getCurrentStatusOfLatestBatchError) {
            stopPolling();
            setQueryError(true);
            showBatchAlertVar(false);
        }
    }, [getCurrentStatusOfLatestBatchError, stopPolling]);

    /* Side effect when selectedQuarter changed to refetch batch tests result */
    useEffect(() => {
        if (selectedQuarter !== '' && !getPreviousBatch) {
            const quarter = Math.floor(selectedQuarter.getMonth() / 3 + 1);
            const year = selectedQuarter.getFullYear();
            const qtrValue = `q${quarter}_${year}`;
            getQuarterFilteredData({
                variables: {
                    input: {
                        period: qtrValue,
                        tenantId,
                    },
                },
            });
            setOneTimeFlag(false);
        }
    }, [selectedQuarter, getPreviousBatch]);

    /* Side effect when getFFIEC031SummaryDetailsForDownload changed */
    useEffect(() => {
        if (getFFIEC031SummaryDetailsForDownload && getFFIEC031SummaryDetailsForDownload.length > 0) {
            const json = getFFIEC031SummaryDetailsForDownload;
            const fields = Object.keys(json[0]);
            const replacer = (key, value) => (value === null ? '' : value);
            let csv = json.map(row => fields.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
            csv.unshift(fields.join(','));
            csv = csv.join('\r\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            saveAs(blob, `${regulation}_result.csv`);
        }
    }, [getFFIEC031SummaryDetailsForDownload]);

    return (
        <DiagnosticResultsUI
            breadcrumbItems={breadcrumbItems}
            summaryQuartersData={summaryQuartersData}
            onNavigate={onNavigate}
            commonData={oneTimeFlag ? (data && data.getFFIEC031BatchTests) : (filteredBatchTests.data && filteredBatchTests.data.getFFIEC031BatchTestsByQuarter)}
            columns={columns}
            selectedQuarter={selectedQuarter}
            setSelectedQuarter={setSelectedQuarter}
            uploadReport={uploadReport}
            onNavigateToResult={onNavigateToResult}
            pageName="FFIEC031 Diagnostic Results"
            downloadResult={downloadResult}
            isDownloading={isDownloading}
            isBatchTestDataLoading={isLoading}
            latestBatch={getCurrentStatusOfLatestBatchForFFIEC031}
            getPreviousBatch={getPreviousBatch}
            showSuccessAlert={showSuccessAlert}
            getLatestBatch={getLatestBatch}
            showBatchAlert={showBatchAlert}
            queryError={queryError}
        />
    );
};

export default FFIEC031LandingPage;
